import { useState, useEffect } from "react";
import { villesMadagascar } from "../../constant/villesMadagascar";
import {
  isPhoneValid,
  filterPhoneInput,
  PHONE_ERROR_MESSAGE,
} from "../../utils/formaNumber";

const ArticleCreateStep2 = ({
  setShowIconPicker,
  showIconPicker,
  BOOTSTRAP_ICONS,
  selectedIcon,
  setSelectedIcon,
  infoValue,
  setInfoValue,
  addInfoCle,
  infoCle,
  removeInfoCle,
  formArticle,
  handleChange,
  phoneError,
  setPhoneError,
  validePhoneNumberInfo,
  setValidePhoneNumberInfo
}) => {
  
  const handlePhoneChange = (e) => {
    const filtered = filterPhoneInput(e.target.value);
    handleChange({
      target: { name: "phone", value: filtered },
    });

    setPhoneError(isPhoneValid(filtered, true) ? "" : PHONE_ERROR_MESSAGE);

    if(isPhoneValid(filtered, true)){
      setValidePhoneNumberInfo(true);
    }else{
      setValidePhoneNumberInfo(false);
    }
  };

  return (
    <div className="container">
      <div className="article_create_form_section_create">
        <h3 className="article_create_subtitle">Emplacement</h3>
        <select
          name="ville"
          value={formArticle.ville}
          onChange={handleChange}
          className="article_create_modern_input"
        >
          <option value="">Choisir une ville</option>
          {[...villesMadagascar].sort().map((ville, index) => (
            <option key={index} value={ville}>
              {ville}
            </option>
          ))}
        </select>
        <input
          name="quartier"
          value={formArticle.quartier}
          placeholder="Quartier"
          onChange={handleChange}
          className="article_create_modern_input"
        />
      </div>
      <h3 className="article_create_subtitle">Contact</h3>
      <div className="form-section-create">
        <input
          name="email"
          value={formArticle.email}
          placeholder="Email"
          onChange={handleChange}
          className="article_create_modern_input"
        />

        <input
          name="phone"
          value={formArticle.phone}
          placeholder="Téléphone"
          onChange={handlePhoneChange}
          className="article_create_modern_input"
        />
        {formArticle.phone && phoneError && (
          <p className="payment_input_error">{phoneError}</p>
        )}
      </div>
      <h3 className="article_create_subtitle" style={{ display: "none" }}>
        Informations clés
      </h3>
      <h3 className="article_create_subtitle" style={{ display: "none" }}>
        {showIconPicker ? (
          <i
            class="bi bi-arrow-up-circle-fill"
            onClick={() => setShowIconPicker((v) => !v)}
          ></i>
        ) : (
          <i
            class="bi bi-arrow-down-circle-fill"
            onClick={() => setShowIconPicker((v) => !v)}
          ></i>
        )}
      </h3>

      <div className="info-cle-container" style={{ display: "none" }}>
        {showIconPicker && (
          <div className="info-cle-picker">
            {BOOTSTRAP_ICONS.map((item, i) => (
              <button
                key={i}
                type="button"
                className={`icon-choice ${
                  selectedIcon?.icon === item.icon ? "active" : ""
                }`}
                onClick={() => setSelectedIcon(item)}
                title={item.label}
              >
                <i className={`bi bi-${item.icon}`} />
                <span>{item.label}</span>
              </button>
            ))}
          </div>
        )}

        {/* Champ valeur */}
        {selectedIcon && (
          <div className="info-cle-input fade-in" style={{ display: "none" }}>
            <input
              type="text"
              placeholder={`Valeur pour ${selectedIcon.label}`}
              value={infoValue}
              onChange={(e) => setInfoValue(e.target.value)}
              className="article_create_modern_input"
            />
            <button className="btn-add-info" onClick={addInfoCle}>
              Ajouter
            </button>
          </div>
        )}

        {/* Liste des infos ajoutées */}
        <div className="info-cle-list" style={{ display: "none" }}>
          {infoCle.map((item, i) => (
            <div key={i} className="info-cle-chip">
              <i className={`bi bi-${item.icon}`} />
              <strong>{item.name}:</strong> {item.value}
              <i
                className="bi bi-trash3"
                onClick={() => removeInfoCle(i)}
                style={{ color: "var(--couleur-secondaire)" }}
              ></i>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ArticleCreateStep2;
